import { isNowOrPast } from '@fora-monorepo/date-utils';
import {
  AddEmploymentInput,
  EmploymentPeriodStatusEnum,
  EmploymentViewModelNew,
  MarkupStatusEnum,
} from '@fora-monorepo/employer-my-pages-common/types';

export const mockAddEmployment = (addEmploymentInput: AddEmploymentInput): EmploymentViewModelNew => {
  return {
    foraAgreementNumber: '00000000004010000783',
    policyNumber: '7000000319',
    employee: {
      employeeId: addEmploymentInput.employeeId,
      partnerNumberIndividual: '0077665544',
      identificationType: addEmploymentInput.identificationType,
      firstName: addEmploymentInput.firstName,
      lastName: addEmploymentInput.lastName,
      birthDate: '',
      deathDate: '',
      isVerified: false,
      address: {
        coAddress: addEmploymentInput.addressInfo?.coAddress,
        streetAddress: addEmploymentInput.addressInfo?.streetAddress ?? '',
        streetAddress2: addEmploymentInput.addressInfo?.streetAddress2 ?? '',
        postalCode: addEmploymentInput.addressInfo?.postalCode,
        city: addEmploymentInput.addressInfo?.city ?? '',
        countryCode: addEmploymentInput.addressInfo?.countryCode ?? '',
      },
    },

    employmentPeriods: addEmploymentInput.employmentPeriods.map(empPeriod => ({
      ...empPeriod,
      employmentStatus: EmploymentPeriodStatusEnum.Active,
      markups: empPeriod.markups.map(markup => ({
        faGroupId: '0000039884',
        status: MarkupStatusEnum.Active,
        fokText: 'FOK123MOCK foktext',
        endDate: null,
        ...markup,
      })),
      fokParameterChoices: empPeriod.fokParameterChoices.map(fokParameterChoice => ({
        startDate: fokParameterChoice.startDate ?? '2024-01-01',
        endDate: fokParameterChoice.endDate ?? null,
        ...fokParameterChoice,
      })),
    })),
    activeMarkup: isNowOrPast(addEmploymentInput.employmentPeriods[0].markups[0].startDate)
      ? {
          ...addEmploymentInput.employmentPeriods[0].markups[0],
          faGroupId: '0000039884',
          endDate: null,
          fokText: addEmploymentInput.employmentPeriods[0].markups[0].fokId,
          fokParameterChoices: [],
          fokIsExpiring: null,
          status: MarkupStatusEnum.Active,
        }
      : null,
    hasFokParameterChoices: addEmploymentInput.employmentPeriods[0].fokParameterChoices?.length > 0,
    isInactive: false,
    isTerminated: false,
    isFuture: false,
  };
};
